import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=3859e4b1&scoped=true"
import script from "./StoreList.vue?vue&type=script&lang=js"
export * from "./StoreList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3859e4b1",
  null
  
)

export default component.exports